<template>
<div class="custom d-inline">
  <bee-label class="custom d-inline" :bold="bold" :color="color" :empty-state="emptyState" :content="type ? getValueForType(type) : date"></bee-label>
</div>
</template>
<script>
import { format, parseISO } from "date-fns";
/**
 * @displayName bee-date-label
 * 
 * @example ../../../../../docs/components/beeDateLabel.md
 */
export default {
props: ["date", "type", "emptyState", "color", "bold"],
name: "BeeDateLabel",
methods: {
    getValueForType(type) {
		switch (type) {
			case 'day': return this.date ? format(parseISO(this.date.toString()), "eeee") : this.date;
			case 'date': return this.date ? format(parseISO(this.date.toString()), "MMMM dd yyyy") : this.date;
		}
    }
}
}
</script>
<style>
.custom {
    caret-color: auto !important;
    font-family: Calibri !important;
    font-weight: 550 !important;
    font-size: 1.05rem !important;
}
</style>
